<template>
  <div
    :class="[
      bem.b(),
      bem.is(isGray ? 'gray-input-number' : ''),
      bem.is(showAmountChinese ? 'show-amount-chinese' : ''),
    ]"
    v-bind="containerAttrs"
  >
    <a-input-number
      ref="inputRef"
      v-bind="componentAttrs"
      v-model:value="innerValue"
      @change="onChange"
    >
      <template
        v-for="item in Object.keys($slots).filter(
          (name) => name !== 'addonAfter'
        )"
        #[item]="data"
      >
        <slot :name="item" v-bind="data || {}"></slot>
      </template>

      <!-- 单独处理 addonAfter 插槽 -->
      <template v-if="$slots.addonAfter || unit" #addonAfter>
        <slot v-if="$slots.addonAfter" name="addonAfter"></slot>
        <template v-else-if="unit"> {{ unit }} </template>
      </template>
    </a-input-number>

    <!-- 中文大写金额 -->
    <span v-if="showAmountChinese" :class="bem.e('amount-chinese-name')">
      {{ getAmountChinese(Number(innerValue)) }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import { createNamespace, getAmountChinese } from '@ll-plus/utils'

import type { InputNumberProps } from 'ant-design-vue'
import { isNil, omit } from 'lodash-es'
import { computed, ref, useAttrs, watch } from 'vue'
import { integerDict, type Integer } from './config'
import { inputNumberEmits, inputNumberProps } from './input-number'

defineOptions({ name: 'LlInputNumber', inheritAttrs: false })

const props = defineProps(inputNumberProps)
const emit = defineEmits(inputNumberEmits)

const bem = createNamespace('input-number')

const attrs = useAttrs()

const innerValue = ref('')
const inputRef = ref()

// 容器样式
const containerAttrs = computed(() => ({
  class: attrs.class as any,
  style: attrs.style as any,
}))

// 组件属性
const componentAttrs = computed(() => {
  const bindValue = {
    ...omit(attrs, ['class', 'style']),
    ...integerConfig.value,
  } as InputNumberProps & { unit: string }

  return bindValue
})

const showAmountChinese = computed(
  () => props.isAmountChinese && !isNil(innerValue.value)
)

const integerConfig = computed(() => {
  let obj = {} as Integer
  if (props.integer) {
    obj = integerDict[props.integer]
  }
  return obj
})

const setValue = (value: any) => {
  innerValue.value = isNil(value) || isNaN(value) ? null : value
}
const onChange = (value: any) => {
  emit('update:value', value)
  emit('change', value)
}

const focus = () => {
  inputRef.value.focus()
}

watch(
  () => props.value,
  (val) => {
    setValue(val)
  },
  { immediate: true }
)

defineExpose({ focus })
</script>
